'use client'

import { Check } from 'lucide-react'

interface Step {
    id: number
    name: string
    completed: boolean
}

export function Stepper({ steps = [], currentStep = 0 }: { steps: Step[], currentStep: number }) {
    return (
        <div className=" py-4 md:py-8 px-4 md:px-0 bg-[linear-gradient(90deg,_#DBF8EC_0%,_#E8FFF5_96.49%)]">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
                <div className="flex justify-between items-center relative w-full">
                    {steps.map((step, index) => {
                    const isCompleted = index < currentStep;
                    const isActive = index === currentStep;

                    return (
                        <div key={index} className="flex-1 flex flex-col items-center relative">
                        {/* Line Connector */}
                        {index !== 0 && (
                            <div className="absolute -left-1/2 top-3 w-full h-[2px] bg-green-400 z-0 rtl:left-auto rtl:-right-1/2"></div>
                        )}

                        {/* Circle */}
                        <div className={`z-10 w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center 
                            ${isCompleted || isActive ? 'bg-green-400 text-white' : 'bg-white text-gray-700'}
                        `}>
                            {isCompleted ? <Check size={14} /> : index + 1 }
                        </div>

                        {/* Label */}
                        <span className={`mt-2 text-sm text-center 
                            ${isCompleted || isActive ? 'text-green-400 font-medium' : 'text-gray-500'}
                        `}>
                            {step.name}
                        </span>
                        </div>
                    );
                    })}
                </div>
            </div>
        </div>
    )
}